$(document).ready(function() {
$('br').attr('aria-hidden','true');
$('img[src*="Logos.png"]').attr('alt', 'Company Logos of FOX, ABC, Ocean Drive, Huffmag, NBC, and MSN');
$('img[src="//www.nutritist.us/cdn/shop/files/preview_images/67121d3f41854676b33ad6fc8048e184.thumbnail.0000000000_small.jpg?v=1747898297"]').attr('alt', 'Visual representation of the human body, emphasizing the throat and its role in the respiratory system');
$('h2, h3, h4, h5, h6').each(function() {
  if ($.trim($(this).text()) === '') {
    $(this).remove();
  }
});

// Convert homepage heading h1 to h2
$('.rich-text__text.rte.scroll-trigger.animate--slide-in h1').each(function() {
    const content = $(this).html();
    $(this).replaceWith('<h2 style="font-size: 40px;">' + content + '</h2>');
});

// Social and External link warning Fixed
$(document).ready(function() {
  // Get current hostname (normalized: no 'www.' or protocol)
  const currentHost = window.location.hostname.replace('www.', '');

  // Select all HTTP/HTTPS links (excluding internal links, mailto, tel, and anchors)
  $('a[href^="http://"], a[href^="https://"]').each(function() {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    // Skip if link is internal or has no valid host (e.g., #anchor links)
    if (linkHost === currentHost || !linkHost) return;

    // Get link text (trimmed) or fallback to "this link"
    const linkText = $link.text().trim() || 'this link';
    const currentAriaLabel = $link.attr('aria-label');

    // Set aria-label (preserve existing or use link text + warning)
    $link.attr({
      'aria-label': currentAriaLabel 
        ? `${currentAriaLabel} (this link will open in new tab)` 
        : `${linkText} (this link will open in new tab)`,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });
    $link.attr({
      'title': currentAriaLabel 
        ? `${currentAriaLabel} (this link will open in new tab)` 
        : `${linkText} (this link will open in new tab)`,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });

    // Optional: Add visual indicator (e.g., ↗)
    $link.addClass('external-link');
  });
});

/// For All Phone Numbers
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    // Only add if not already present
    if (!existingLabel.includes('Number')) {
      const newLabel = `Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 
});


// List of Email aria label assaigned
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});







});

//faq
$(document).ready(function () {
  $('.js-grodas-ac-card-button').on('click', function () {
    const $clickedButton = $(this);
    const $clickedCard = $clickedButton.closest('.grodas-ac-card');
    const $clickedContent = $clickedCard.find('.grodas-ac-card__content');
    const isExpanded = $clickedButton.attr('aria-expanded') === 'true';

    // First, collapse all
    $('.js-grodas-ac-card-button').attr('aria-expanded', 'false');
    $('.grodas-ac-card__content').attr('hidden', true);

    // Then, expand only the clicked one if it was not already expanded
    if (!isExpanded) {
      $clickedButton.attr('aria-expanded', 'true');
      $clickedContent.removeAttr('hidden');
    }
  });
});
